var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "col-xs-12 col-sm-12 col-lg-8",
          class: _vm.isDefault ? "col-md-8" : "col-md-12",
        },
        [
          _c(
            "div",
            {
              staticClass: "widget-card carousel-position",
              class: _vm.isDefault
                ? "headlines-ht"
                : "customised-headlines-ht mb-20",
            },
            [
              _c("div", { staticClass: "header d-flex align-items-center" }, [
                _c("img", {
                  attrs: { src: "/static/images/icons/headline.svg" },
                }),
                _c("h3", { staticClass: "title fw-500 m-0" }, [
                  _vm._v("Headlines"),
                ]),
                _vm.roleId === 5 || _vm.roleId === 7
                  ? _c(
                      "div",
                      { staticClass: "admin-features align-right p-0" },
                      [
                        _c(
                          "span",
                          {
                            class:
                              _vm.regulatoryHeadlines.length >= 8
                                ? "cursor-pointer-disable"
                                : "cursor-pointer",
                            on: {
                              click: function ($event) {
                                _vm.regulatoryHeadlines.length >= 8
                                  ? ""
                                  : _vm.openAddPopup()
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "margin-icon",
                              attrs: {
                                src: "/static/images/icons/plus_icon_blue.svg",
                              },
                            }),
                            _c(
                              "span",
                              { staticClass: "admin-features-label" },
                              [_vm._v("Upload New")]
                            ),
                          ]
                        ),
                        _vm.regulatoryHeadlines.length >= 8
                          ? _c(
                              "el-popover",
                              {
                                staticClass: "cursor-pointer",
                                attrs: {
                                  placement: "bottom-end",
                                  trigger: "click",
                                  width: "350",
                                },
                                on: {
                                  show: function ($event) {
                                    _vm.infoActive = true
                                  },
                                  hide: function ($event) {
                                    _vm.infoActive = false
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "limit_popover_txt" },
                                  [
                                    _vm._v(
                                      " Max 8 main headlines can be added. Please delete and try again "
                                    ),
                                  ]
                                ),
                                !_vm.infoActive
                                  ? _c("img", {
                                      staticClass: "info-img",
                                      attrs: {
                                        slot: "reference",
                                        src: "/static/images/icons/info_icon.svg",
                                      },
                                      slot: "reference",
                                    })
                                  : _vm._e(),
                                _vm.infoActive
                                  ? _c("img", {
                                      staticClass: "info-img",
                                      attrs: {
                                        slot: "reference",
                                        src: "/static/images/icons/info_icon_active.svg",
                                      },
                                      slot: "reference",
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.regulatoryHeadlines.length > 0
                          ? _c(
                              "span",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.openDeletePopup()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "margin-icon",
                                  attrs: {
                                    src: "/static/images/icons/delete_icon.svg",
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass: "admin-features-label delete",
                                  },
                                  [_vm._v("Delete")]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c("div", { staticClass: "headline-content pl-0 pr-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "carousel text-center carousel-style",
                    attrs: {
                      id: "myCarousel",
                      "data-ride": "carousel",
                      "data-interval": "3000",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "carousel-inner item-hover",
                        attrs: { role: "listbox" },
                      },
                      _vm._l(_vm.regulatoryHeadlines, function (alert, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "item align-left",
                            class: { active: index == 0 },
                          },
                          [
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "row mr-0 date-container" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-12 date-css fw-500 pr-0 align-left",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("UTCDate")(
                                              alert.display_date,
                                              "MMM DD, YYYY"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "heading text-emergo-dark-blue fw-400",
                                  class: { "url-hover": alert.redirection_url },
                                },
                                [
                                  !alert.redirection_url
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: "javascript:void(0);",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "headlines-img pb-20",
                                            attrs: {
                                              src: _vm.getImageUrl(alert.image),
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(alert.title)),
                                          ]),
                                        ]
                                      )
                                    : alert.redirection_url &&
                                      _vm.selfURL(alert.redirection_url)
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: _vm.getPathFromURL(
                                              alert.redirection_url
                                            ),
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "headlines-img pb-20",
                                            attrs: {
                                              src: _vm.getImageUrl(alert.image),
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(alert.title)),
                                          ]),
                                        ]
                                      )
                                    : alert.redirection_url &&
                                      !_vm.selfURL(alert.redirection_url)
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: alert.redirection_url,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "headlines-img pb-20",
                                            attrs: {
                                              src: _vm.getImageUrl(alert.image),
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(_vm._s(alert.title)),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c("p", {
                                staticClass:
                                  "headline-details fw-400 word-break",
                                domProps: {
                                  innerHTML: _vm._s(alert.description),
                                },
                              }),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "carousel-indicators-container d-flex position-relative",
                        class: {
                          "justify-content-center": !(
                            _vm.roleId === 5 || _vm.roleId === 7
                          ),
                          "justify-space-between":
                            _vm.roleId === 5 || _vm.roleId === 7,
                        },
                      },
                      [
                        _c(
                          "ol",
                          { staticClass: "carousel-indicators" },
                          _vm._l(
                            _vm.regulatoryHeadlines,
                            function (alert, index) {
                              return _c("li", {
                                key: index,
                                class: { active: index === 0 },
                                attrs: {
                                  "data-target": "#myCarousel",
                                  "data-slide-to": index,
                                },
                              })
                            }
                          ),
                          0
                        ),
                        _vm.roleId === 5 || _vm.roleId === 7
                          ? _c("div", [
                              _vm.regulatoryHeadlines.length > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "cursor-pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.openEditPopup(
                                            "Main Headline"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v("   "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "admin-features-label see-all-label fw-500",
                                        },
                                        [_vm._v("See All ")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]
                ),
                _c("div", { staticClass: "separator-line p-0" }),
              ]),
            ]
          ),
        ]
      ),
      _c("add-popup", {
        attrs: {
          userId: _vm.userId,
          propId: _vm.propId,
          editObjects: _vm.editObj,
          operations: _vm.operationForAdd,
          index: _vm.neHeadlineIndex,
        },
        on: {
          reload: function ($event) {
            return _vm.getRegulatoryHeadlines()
          },
          reloadList: _vm.reloadList,
        },
      }),
      _c("list-popup", {
        attrs: { operations: _vm.operations, propId: _vm.propId },
        on: {
          openModalDelete: _vm.openModalDeleteForList,
          onOpenEditPopup: _vm.handleOpenEditPopup,
          closeList: _vm.handleCloseListPopup,
          selectedHeadLinesList: _vm.setSelectedHeadLines,
        },
      }),
      _c("delete-popup", {
        attrs: { propId: _vm.propId, deletewarnInfo: _vm.deleteWarningInfo },
        on: {
          dashboardPublishDelete: function ($event) {
            return _vm.dashboardPublishDelete()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }